<template>
  <div>
    <div class="text-2xl font-black leading-tight font-display mb-2">
      {{ item.name }}
      <span
        v-if="item.meta.required"
        class="text-sm"
      >(Required)</span>
    </div>
    <div
      v-if="item.meta.help_text"
      class="mb-4"
    >
      {{ item.meta.help_text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
